import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=55051c93"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55051c93')) {
      api.createRecord('55051c93', component.options)
    } else {
      api.reload('55051c93', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=55051c93", function () {
      api.rerender('55051c93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Menu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Menu.vue
// module id = 138
// module chunks = 0